// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_77-0";
export var optionCard = "_77-1";